import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AdminSlider.css";
import AdminNavbar from "./AdminNavbar";
import ImageWithLoader from "./ImageWithLoader"; // ⬅️ import added

function AdminSlider() {
  const [images, setImages] = useState([]);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    const res = await axios.get("https://himchatterjee.in/backend/get_slider.php");
    setImages(res.data);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file || !title) return alert("Please select an image and enter a title!");
    const formData = new FormData();
    formData.append("image", file);
    formData.append("title", title);
    await axios.post("https://himchatterjee.in/backend/add_slider.php", formData);
    setFile(null);
    setTitle("");
    fetchImages();
  };

  const handleDelete = async (id) => {
    await axios.post("https://himchatterjee.in/backend/delete_slider.php", { id });
    fetchImages();
  };

  return (
    <>
      <AdminNavbar />

      <div className="slider-page">
        {/* Notice Box */}
        <div className="notice-box">
          <strong>Note:</strong> Only 4 images will be shown in the slider. Add only four images. 
          Current images: <span className="img-count">{images.length}</span>
        </div>

        {/* Upload Field */}
        <form onSubmit={handleUpload} className="upload-form">
          <input type="file" onChange={(e) => setFile(e.target.files[0])} />
          <input
            type="text"
            placeholder="Enter Image Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <button type="submit">Add Image</button>
        </form>

        {/* Images Table */}
        <table className="images-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Title</th>
              <th>Option</th>
            </tr>
          </thead>
          <tbody>
            {images.map((img) => (
              <tr key={img.id}>
                <td>
                  <ImageWithLoader
                    src={`https://himchatterjee.in/backend/uploads/${img.name}`}
                    alt={img.title || "Image"}
                    width={80}
                    height={80}
                  />
                </td>
                <td>{img.title}</td>
                <td>
                  <button className="delete-btn" onClick={() => handleDelete(img.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default AdminSlider;
